export default "__VITE_ASSET__a1c47325__"